// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__159Sn","colBig":"styles_colBig__3Y0NL","colSmall":"styles_colSmall__21Ypp"};